'use client';

import { Calendar } from '@hassanmojab/react-modern-calendar-datepicker';
import type { DayValue } from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

type CalendarDay = Exclude<DayValue, null | undefined>;

export type PersianCalendarProps = {
  value: DayValue;
  onChange?: (value: DayValue) => void;
  minimumDate?: CalendarDay;
  maximumDate?: CalendarDay;
  shouldHighlightWeekends?: boolean;
  calendarClassName?: string;
};

export default function PersianCalendar({
  value,
  onChange,
  minimumDate,
  maximumDate,
  shouldHighlightWeekends,
  calendarClassName,
}: PersianCalendarProps) {
  return (
    <Calendar
      value={value}
      onChange={onChange}
      minimumDate={minimumDate}
      maximumDate={maximumDate}
      locale='fa'
      shouldHighlightWeekends={shouldHighlightWeekends}
      calendarClassName={calendarClassName}
      renderFooter={() => null}
      customDaysClassName={[]}
      disabledDays={[]}
      onDisabledDayError={() => {}}
    />
  );
}
